import React, { useState } from 'react'
import LessonIndex from './LessonIndex.js'
import TopBar from './TopBar.js'
import Register from './Register.js'

const storage = window.localStorage

function Dashboard(props) {
  const [status, setStatus] = useState(storage.getItem('user') != null)
  function logIn() {setStatus(true)}
  if (status) {
    return (
      <div className="Dashboard" >
      <TopBar user={JSON.parse(storage.getItem('user'))} />
        <h1>Learn the Arabic abjad</h1>
      <LessonIndex />
      </div>
    )
  } else {
    return (<Register loggedIn={logIn} />)
  }

}

export default Dashboard
